import { makeStyles } from "@material-ui/core";

export const earnedPointsStyles = makeStyles((theme) => ({
  pointsDetails: {
    color: "#000000",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    "& svg": {
      margin: "0px 2px 0px 2px",
    },
  },
}));
